import React from 'react';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  SearchOutlined,
  ShopOutlined,
  UserDeleteOutlined,
  UserOutlined,
  ShareAltOutlined,
  PictureOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { canViewDashboard, canViewSoftwareUsage } from '../../utils/permissions';
import LogoMark from '../../assets/logo-mark.png';
import './index.css';

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const canManageBanners = ['admin', 'service'].includes(user?.role);
  const canAccessDashboard = canViewDashboard(user);
  const canAccessSoftwareUsage = canViewSoftwareUsage(user);

  const menuItems = [
    ...(canAccessDashboard ? [
      {
        key: '/dashboard',
        icon: <DashboardOutlined />,
        label: '仪表盘',
      },
    ] : []),
    {
      key: '/order-fill',
      icon: <FileTextOutlined />,
      label: '订单填写',
    },
    {
      key: '/order-place',
      icon: <ShoppingCartOutlined />,
      label: '排单',
    },
    {
      key: '/query-info',
      icon: <SearchOutlined />,
      label: '查询信息',
    },
    {
      key: '/stores',
      icon: <ShopOutlined />,
      label: '店铺信息',
    },
    {
      key: '/recruitment',
      icon: <ShareAltOutlined />,
      label: '招聘推广',
    },
    {
      key: '/blacklist',
      icon: <UserDeleteOutlined />,
      label: '黑名单',
    },
    ...(canManageBanners ? [
      {
        key: '/banners',
        icon: <PictureOutlined />,
        label: '轮播图管理',
      },
    ] : []),
    ...(user?.role === 'admin' ? [
      {
        key: '/users',
        icon: <UserOutlined />,
        label: '用户管理',
      },
    ] : [])
    , ...(canAccessSoftwareUsage ? [
      {
        key: '/software-usage',
        icon: <SafetyCertificateOutlined />,
        label: '软件使用管理',
      },
    ] : [])
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <aside className={`app-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon">
            <img src={LogoMark} alt="星火查挂" />
          </div>
          {!collapsed && (
            <div className="logo-text">
              <div className="logo-title">星火查挂</div>
            </div>
          )}
        </div>
      </div>
      
      <div className="sidebar-content">
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          className="sidebar-menu"
        />
      </div>
    </aside>
  );
};

export default Sidebar;
